var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation-UX-(New)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.699999988
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_New-Update-(Desktop)",
    transform: "translate(-20.000000, -274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-4",
    transform: "translate(0.000000, 212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(13.500000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "League-Icon",
    transform: "translate(6.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "League-Icon-(Background/Mask)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,13.75 C7.45617284,13.75 4.58333333,10.8771605 4.58333333,7.33333333 C4.58333333,3.78950618 7.45617284,0.916666667 11,0.916666667 C14.5438272,0.916666667 17.4166667,3.78950618 17.4166667,7.33333333 C17.4166667,10.8771605 14.5438272,13.75 11,13.75 Z",
    id: "League-Vector-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52583337,12.7323928 L6.41666667,21.0832258 L11,18.3332258 L15.5833333,21.0832258 L14.4741666,12.7232259",
    id: "League-Vector-1",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeague);
export default __webpack_public_path__ + "static/media/League.db4b39864b0c807bfbdceda51d6a3d7e.svg";
export { ForwardRef as ReactComponent };